module.exports = __webpack_public_path__ + "img/beijing.e5f7e777.png";